<svg class="h-0 w-0">
  <linearGradient id="dine-enabled" x1="256" x2="256" y1="-2.79" y2="501.88" gradientUnits="userSpaceOnUse">
    <stop offset="0" style="stop-color:#7ee48f"></stop>
    <stop offset="1" style="stop-color:#00B59C"></stop>
  </linearGradient>
  <linearGradient id="dine-disabled" x1="256" x2="256" y1="-2.79" y2="501.88" gradientUnits="userSpaceOnUse">
    <stop offset="0" style="stop-color:#fdae3e"></stop>
    <stop offset="1" style="stop-color:#ff0749"></stop>
  </linearGradient>
</svg>

<div class="relative -top-4 flex justify-start gap-4 mobile:block">
  <!-- Dine in -->
  <div *ngIf="hasField('dine_in')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.dine_in ? 'dine in' : 'no dine in'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('dine_in')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>
      <g [attr.fill]="getFill('dine_in')" transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path
          d="M51.943 266.264c-8.822-92.212-22.19-168.086-22.382-169.225L0 102.166c.293 1.714 30 172.852 30 312.437h30c0-29.266-1.3-59.837-3.301-90H151v90h30v-120c0-27.44-18.102-30-45.234-30l-58.539.015c-9.637 0-18.143.216-25.284 1.646z"
          fill="" data-original="#000000" class=""></path>
        <path d="M241 384.603h-30v30h90v-30h-30v-180h120v-60H121v60h120z" fill="" data-original="#000000" class="">
        </path>
        <path
          d="m512 102.166-29.561-5.127c-.192 1.139-13.563 77.012-22.385 169.224-7.141-1.43-15.645-1.646-25.281-1.646l-58.539-.015c-27.133 0-45.234 2.56-45.234 30v120h30v-90.01h94.301C453.3 354.756 452 385.337 452 414.603h30c0-139.585 29.707-310.723 30-312.437z"
          fill="" data-original="#000000" class=""></path>
      </g>

      <!-- <path *ngIf="place.dine.dine_in===false" [attr.fill]="getFill('dine_in')" [attr.stroke]="getFill('dine_in')"
        fill="none" stroke-width="30" d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Dine in</div>
      <div *ngIf="place.dine.dine_in" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.dine_in" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>


  <!-- take out -->
  <div *ngIf="hasField('takeout')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.takeout ? 'takeout' : 'no takeout'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('takeout')" [attr.stroke]="getFill('takeout')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>
      <g [attr.fill]="getFill('takeout')" [attr.stroke]="getFill('takeout')"
        transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path d="M16.694 119.31h211.783v65.928H16.694zM40.909 119.308V60.433h163.354v58.876"
          style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke=""
          stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          data-original="#000000" class=""></path>
        <path
          d="m34.497 185.232 19.399 268.512h137.723l16.951-268.487zM15 372.37h484.176M287.217 119.31H499v65.928H287.217zM311.432 119.308V60.433h163.353v58.876"
          style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke=""
          stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          data-original="#000000" class=""></path>
        <path d="m305.02 185.232 19.399 268.512h137.723l16.95-268.487z"
          style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke=""
          stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
          data-original="#000000" class=""></path>
      </g>
      <!-- <path *ngIf="place.dine.takeout===false" [attr.fill]="getFill('takeout')" [attr.stroke]="getFill('takeout')"
        fill="none" stroke-width="30" d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Takeout</div>
      <div *ngIf="place.dine.takeout" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.takeout" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>

  <!-- deliver -->
  <div *ngIf="hasField('delivery')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.delivery ? 'delivery' : 'no delivery'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g>
        <g [attr.fill]="getFill('delivery')" [attr.stroke]="getFill('delivery')">
          <path
            d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
            fill=""></path>
        </g>
        <g [attr.fill]="getFill('delivery')" fill-rule="evenodd"
          transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
          <path
            d="M342.234 0H261.23c-24.804 0-45 20.195-45 45v26.992h-23c-8.285 0-15 6.719-15 15 0 8.285 6.715 15 15 15h23.325c3.816 43.887 40.664 78.004 85.175 78.004 47.22 0 85.504-38.285 85.504-85.504V45c0-24.805-20.195-45-45-45zM266.777 217.531a86.11 86.11 0 0 0-28.574 20.895l-80.64 82.57H45c-24.781 0-45 20.223-45 45.004 0 24.777 20.223 45 45 45h126.004c13.824 0 27.527-3.473 37.82-13.84l13.41-13.5v113.332c0 7.266 5.16 13.625 12.016 15.008l138.004-.008c8.273-.008 14.98-6.722 14.98-15V295.496c0-61.598-63.984-103.453-120.457-77.965zm0 0"
            fill="" data-original="#000000" class=""></path>
          <path
            d="M41.227 290.996H149.23c8.286 0 15-6.715 15-15v-107c0-8.285-6.714-15-15-15h-39v25.766c0 8.285-6.718 15-15 15-8.285 0-15-6.715-15-15v-25.766H41.227c-8.282 0-15 6.715-15 15v107c0 8.285 6.718 15 15 15zm0 0"
            fill="" data-original="#000000" class=""></path>
        </g>
        <!-- <path *ngIf="place.dine.delivery===false" [attr.fill]="getFill('delivery')" [attr.stroke]="getFill('delivery')"
          fill="none" stroke-width="30" d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
      </g>
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Delivery</div>
      <div *ngIf="place.dine.delivery" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.delivery" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>


  <!-- breakfast -->
  <div *ngIf="hasField('serves_breakfast')" class="svg-container">
    <div class="svg-light"
      matTooltip="{{showText ? '' : place.dine.serves_breakfast ? 'serves breakfast' : 'no breakfast'}}">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0"
        style="enable-background:new 0 0 512 512" xml:space="preserve" class="" viewBox="0 0 512 512">
        <g [attr.fill]="getFill('serves_breakfast')" [attr.stroke]="getFill('serves_breakfast')">
          <path
            d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
            fill=""></path>
        </g>
        <g [attr.fill]="getFill('serves_breakfast')" fill-rule="evenodd"
          transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
          <path d="M155.965 266.95h29.992v29.991h-29.992zm0 0" fill="" data-original="#000000"></path>
          <path
            d="M211.074 182.965c-65.047 0-117.96 52.918-117.96 117.96s52.917 117.962 117.96 117.962 117.961-52.914 117.961-117.961-52.918-117.961-117.96-117.961zm0 205.93c-48.508 0-87.969-39.461-87.969-87.97 0-48.503 39.461-87.968 87.97-87.968 48.503 0 87.968 39.465 87.968 87.969 0 48.504-39.465 87.969-87.969 87.969zm0 0"
            fill="" data-original="#000000"></path>
          <path
            d="M474.445 201.156c-11.386-12.734-17.703-29.398-17.793-46.926-.004-1.03-.02-2.066-.047-3.101C454.54 67.379 385.2 0 301.594 0c-.676 0-1.356.004-2.031.012C246.02.71 197.335 28.437 169.327 74.18c-8.55 13.965-21.098 24.539-36.273 30.582-39.18 15.593-72.508 42.304-96.38 77.238C12.212 217.805-.468 259.754.013 303.309c.62 56.058 22.832 108.554 62.543 147.816C102.262 490.383 155.008 512 211.075 512c57.538 0 111.308-22.738 151.41-64.023 14.855-15.293 33.296-26.723 53.327-33.047 26.555-8.387 49.422-24.676 66.13-47.114C498.991 344.922 508 317.691 508 289.07c0-32.488-11.918-63.71-33.555-87.914zm-67.664 185.172c-24.75 7.813-47.508 21.906-65.812 40.75-34.403 35.422-80.531 54.93-129.895 54.93-98.75 0-179.98-80.313-181.066-179.031-.824-74.387 45.047-142.848 114.137-170.348 21.246-8.457 38.8-23.25 50.761-42.785 22.598-36.906 61.867-59.274 105.047-59.84.55-.008 1.09-.012 1.637-.012 67.43 0 123.363 54.344 125.031 121.883.024.84.035 1.676.04 2.512.124 24.851 9.155 48.558 25.425 66.758a101.794 101.794 0 0 1 25.922 67.925c0 44.72-28.625 83.805-71.227 97.258zm0 0"
            fill="" data-original="#000000"></path>
        </g>
        <!-- <path *ngIf="place.dine.serves_breakfast===false" [attr.fill]="getFill('serves_breakfast')"
        [attr.stroke]="getFill('serves_breakfast')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
      </svg>
    </div>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Breakfast</div>
      <div *ngIf="place.dine.serves_breakfast" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.serves_breakfast" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>

  <!-- brunch -->
  <div *ngIf="!hasField('serves_breakfast')&&hasField('serves_brunch')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.serves_brunch ? 'serves breakfast' : 'no breakfast'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="" viewBox="0 0 512 512">
      <g [attr.fill]="getFill('serves_brunch')" [attr.stroke]="getFill('serves_brunch')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>
      <g [attr.fill]="getFill('serves_brunch')" fill-rule="evenodd"
        transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path d="M155.965 266.95h29.992v29.991h-29.992zm0 0" fill="" data-original="#000000"></path>
        <path
          d="M211.074 182.965c-65.047 0-117.96 52.918-117.96 117.96s52.917 117.962 117.96 117.962 117.961-52.914 117.961-117.961-52.918-117.961-117.96-117.961zm0 205.93c-48.508 0-87.969-39.461-87.969-87.97 0-48.503 39.461-87.968 87.97-87.968 48.503 0 87.968 39.465 87.968 87.969 0 48.504-39.465 87.969-87.969 87.969zm0 0"
          fill="" data-original="#000000"></path>
        <path
          d="M474.445 201.156c-11.386-12.734-17.703-29.398-17.793-46.926-.004-1.03-.02-2.066-.047-3.101C454.54 67.379 385.2 0 301.594 0c-.676 0-1.356.004-2.031.012C246.02.71 197.335 28.437 169.327 74.18c-8.55 13.965-21.098 24.539-36.273 30.582-39.18 15.593-72.508 42.304-96.38 77.238C12.212 217.805-.468 259.754.013 303.309c.62 56.058 22.832 108.554 62.543 147.816C102.262 490.383 155.008 512 211.075 512c57.538 0 111.308-22.738 151.41-64.023 14.855-15.293 33.296-26.723 53.327-33.047 26.555-8.387 49.422-24.676 66.13-47.114C498.991 344.922 508 317.691 508 289.07c0-32.488-11.918-63.71-33.555-87.914zm-67.664 185.172c-24.75 7.813-47.508 21.906-65.812 40.75-34.403 35.422-80.531 54.93-129.895 54.93-98.75 0-179.98-80.313-181.066-179.031-.824-74.387 45.047-142.848 114.137-170.348 21.246-8.457 38.8-23.25 50.761-42.785 22.598-36.906 61.867-59.274 105.047-59.84.55-.008 1.09-.012 1.637-.012 67.43 0 123.363 54.344 125.031 121.883.024.84.035 1.676.04 2.512.124 24.851 9.155 48.558 25.425 66.758a101.794 101.794 0 0 1 25.922 67.925c0 44.72-28.625 83.805-71.227 97.258zm0 0"
          fill="" data-original="#000000"></path>
      </g>
      <!-- <path *ngIf="place.dine.serves_brunch===false" [attr.fill]="getFill('serves_brunch')"
        [attr.stroke]="getFill('serves_brunch')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Breakfast</div>
      <div *ngIf="place.dine.serves_brunch" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.serves_brunch" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>


  <!-- lunch -->
  <div *ngIf="hasField('serves_lunch')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.serves_lunch ? 'serves lunch' : 'no lunch'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('serves_lunch')" [attr.stroke]="getFill('serves_lunch')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>

      <g [attr.fill]="getFill('serves_lunch')" fill-rule="evenodd"
        transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path
          d="M510.419 357.056c-1.963-3.136-5.397-5.056-9.088-5.056H10.665c-3.691 0-7.125 1.92-9.067 5.056a10.625 10.625 0 0 0-.469 10.368C16.105 397.397 46.206 416 79.699 416h352.597c33.472 0 63.573-18.603 78.592-48.555 1.622-3.328 1.473-7.232-.469-10.389zM285.246 140.885c1.749-3.947 2.752-8.299 2.752-12.885 0-17.643-14.357-32-32-32s-32 14.357-32 32c0 4.587 1.003 8.939 2.752 12.885C130.089 154.176 53.758 232 43.966 330.667h424.043c-9.792-98.624-86.144-176.491-182.763-189.782zm-39.211 61.76c-59.669 3.947-111.061 42.901-130.88 99.243-1.536 4.373-5.675 7.125-10.069 7.125-1.173 0-2.368-.192-3.541-.597-5.547-1.963-8.469-8.043-6.528-13.611 22.656-64.427 81.387-108.949 149.611-113.451 5.653-.363 10.944 4.053 11.349 9.941.384 5.889-4.054 10.966-9.942 11.35z"
          fill="" data-original="#000000"></path>
      </g>

      <!-- <path *ngIf="place.dine.serves_lunch===false" [attr.fill]="getFill('serves_lunch')"
        [attr.stroke]="getFill('serves_lunch')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 ">
      </path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Lunch</div>
      <div *ngIf="place.dine.serves_lunch" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.serves_lunch" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>


  <!-- dinner -->
  <div *ngIf="hasField('serves_dinner')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.serves_dinner ? 'serves dinner' : 'no dinner'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('serves_dinner')" [attr.stroke]="getFill('serves_dinner')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>

      <g [attr.fill]="getFill('serves_dinner')" fill-rule="evenodd"
        transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path
          d="M393.722 438.868 371.37 271.219h.622c6.564 0 11.885-5.321 11.885-11.885V17.668c0-4.176-2.183-8.03-5.751-10.18a11.873 11.873 0 0 0-11.679-.335c-46.345 24.454-75.357 72.536-75.357 124.952v101.898c0 20.551 16.665 37.215 37.218 37.215h2.818l-22.352 167.649a42.91 42.91 0 0 0 10.228 33.886 42.897 42.897 0 0 0 32.246 14.625 42.898 42.898 0 0 0 32.246-14.625 42.906 42.906 0 0 0 10.228-33.885zM207.482 0c-9.017 0-16.314 7.297-16.314 16.313v91.128h-16.314V16.313C174.854 7.297 167.557 0 158.54 0s-16.313 7.297-16.313 16.313v91.128h-16.314V16.313C125.912 7.297 118.615 0 109.599 0c-9.018 0-16.314 7.297-16.314 16.313v147.24c0 24.2 19.611 43.811 43.811 43.811h3.616L115 438.74a43.865 43.865 0 0 0 10.896 34.047 43.82 43.82 0 0 0 32.645 14.592 43.822 43.822 0 0 0 32.645-14.592 43.858 43.858 0 0 0 10.896-34.047l-25.713-231.375h3.617c24.199 0 43.811-19.611 43.811-43.811V16.313C223.796 7.297 216.499 0 207.482 0z"
          fill="" data-original="#000000" class=""></path>
      </g>

      <!-- <path *ngIf="place.dine.serves_dinner===false" [attr.fill]="getFill('serves_dinner')"
        [attr.stroke]="getFill('serves_dinner')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Dinner</div>
      <div *ngIf="place.dine.serves_dinner" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.serves_dinner" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>


  <!-- beer -->
  <div *ngIf="hasField('serves_beer')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.serves_beer ? 'serves beer' : 'no beer'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('serves_beer')" [attr.stroke]="getFill('serves_beer')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>
      <g [attr.fill]="getFill('serves_beer')" transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path
          d="M396.86 189.696h-51.816v-8.471c16.876-12.499 27.84-32.548 27.84-55.113 0-33.43-24.055-61.349-55.764-67.356C307.903 24.725 276.851.001 240.165 0c-20.304.001-39.79 7.852-54.44 21.513a63.586 63.586 0 0 0-16.077-2.072c-25.849 0-48.398 15.683-58.222 38.235a68.614 68.614 0 0 0-4.037-.118c-37.8 0-68.553 30.753-68.553 68.553 0 20.813 9.335 39.475 24.024 52.058v283.526c0 16.5 13.5 30 30 30h222.184c16.5 0 30-13.5 30-30v-44h51.816c30.878 0 56-25.122 56-56v-116c0-30.878-25.122-55.999-56-55.999zm-92.529-33.031H128.795v61.051c0 10.493-8.507 19-19 19s-19-8.507-19-19v-65.971c-8.393-5.452-13.959-14.902-13.959-25.634 0-16.847 13.706-30.553 30.553-30.553a30.4 30.4 0 0 1 11.032 2.062 18.999 18.999 0 0 0 25.826-16.448c.889-13.307 12.046-23.731 25.401-23.731 4.356 0 8.485 1.06 12.27 3.149 8.375 4.622 18.88 2.297 24.523-5.427C214.409 44.256 226.701 38 240.165 38c22.277 0 40.586 17.408 41.682 39.631a18.993 18.993 0 0 0 6.365 13.274 18.981 18.981 0 0 0 13.936 4.744c.884-.062 1.578-.09 2.183-.09 16.847 0 30.553 13.706 30.553 30.553s-13.706 30.553-30.553 30.553zm96.529 205.031c0 2.131-1.869 4-4 4h-51.816v-124h51.816c2.131 0 4 1.869 4 4v116z"
          fill="" data-original="#000000" class=""></path>
      </g>

      <!-- <path *ngIf="place.dine.serves_beer===false" [attr.fill]="getFill('serves_beer')"
        [attr.stroke]="getFill('serves_beer')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 ">
      </path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Beer</div>
      <div *ngIf="place.dine.serves_beer" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.serves_beer" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>

  <!-- wine -->
  <div *ngIf="hasField('serves_wine')" class="svg-container"
    matTooltip="{{showText ? '' : place.dine.serves_wine ? 'serves wine' : 'no wine'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('serves_wine')" [attr.stroke]="getFill('serves_wine')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
        <path
          d="M329.93 124c-1.74-4-9.27-7.64-14.17-7.72q-9.28-.14-18.56-.23h-80.7q-9.84.1-19.68.24c-5 .08-12.66 3.4-14.42 7.31-15.91 35.4-27.16 72.27-17.05 111.4 10.21 39.48 38.11 61.2 77.17 69.33v66.48c-11.8 0-22.61.07-33.42 0-8.37-.08-15.58 2.09-15.79 11.84-.23 10.21 6.94 13.36 15.91 13.37q47 .07 93.9 0c8.27 0 15.45-2.74 15.56-12.39.12-10.36-7-13-16.1-12.83-11.08.21-22.16.05-33.56.05v-66.23c40.05-9.09 68-30.6 77.91-70.39 9.65-38.74-1.67-75.13-17-110.23zm-35 63c-33.83-6.38-66.72-19.12-104.22-12.19L201 141.05c35.15 0 69.35-.16 103.55.29 3 0 7.55 3.59 8.51 6.47 4.21 12.58 7.36 25.51 11.6 40.86-11.27-.6-20.73-.05-29.77-1.76z"
          fill=""></path>
      </g>
      <!-- <path *ngIf="place.dine.serves_wine===false" [attr.fill]="getFill('serves_wine')"
        [attr.stroke]="getFill('serves_wine')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 ">
      </path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Wine</div>
      <div *ngIf="place.dine.serves_wine" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.dine.serves_wine" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>


  <!-- wheelchair -->
  <div *ngIf="hasField('wheelchair_accessible_entrance')" class="svg-container"
    matTooltip="{{showText ? 'Wheelchair accessible entrance' : place.wheelchair_accessible_entrance ? 'has wheelchair accessible entrance' : 'no wheelchair accessible entrance'}}">
    <div class="svg-light"></div>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns:svgjs="http://svgjs.com/svgjs" [attr.width]="size" [attr.height]="size" x="0" y="0" viewBox="0 0 512 512"
      style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
      <g [attr.fill]="getFill('wheelchair_accessible_entrance')"
        [attr.stroke]="getFill('wheelchair_accessible_entrance')">
        <path
          d="M256 30a226.06 226.06 0 0 1 88 434.25 226.06 226.06 0 0 1-176-416.5A224.5 224.5 0 0 1 256 30m0-30C114.61 0 0 114.61 0 256s114.61 256 256 256 256-114.61 256-256S397.39 0 256 0z"
          fill=""></path>
      </g>
      <g [attr.fill]="getFill('wheelchair_accessible_entrance')"
        [attr.stroke]="getFill('wheelchair_accessible_entrance')"
        transform="matrix(0.55,0,0,0.55,115.19999999999999,115.11945648193355)">
        <path
          d="M343.401 380.58c-10.363-4.567-22.446.246-26.911 10.629-21.053 48.497-68.915 79.831-121.938 79.831-73.4 0-133.12-59.72-133.12-133.12 0-47.596 25.641-91.771 66.888-115.343 9.851-5.591 13.251-18.104 7.639-27.935-5.591-9.83-18.125-13.312-27.935-7.619-54.006 30.822-87.552 88.637-87.552 150.897 0 95.99 78.09 174.08 174.08 174.08 69.366 0 131.973-41.021 159.498-104.489 4.506-10.363-.246-22.426-10.649-26.931z"
          fill="" data-original="#000000"></path>
        <path
          d="M490.058 402.002c-4.219-10.527-16.056-15.647-26.624-11.428l-30.638 12.268-44.585-142.705a20.508 20.508 0 0 0-19.579-14.377H222.364l-6.369-40.96h80.957c11.325 0 20.48-9.155 20.48-20.48s-9.155-20.48-20.48-20.48h-87.306l-10.588-68.219c15.565-8.806 26.214-25.293 26.214-44.421 0-28.242-22.958-51.2-51.2-51.2-28.221 0-51.2 22.958-51.2 51.2 0 22.671 14.909 41.718 35.369 48.435l26.317 169.738c1.557 9.994 10.138 17.347 20.234 17.347h148.787l46.694 149.463a20.564 20.564 0 0 0 10.773 12.39 20.319 20.319 0 0 0 8.786 1.987 20.47 20.47 0 0 0 7.619-1.454l51.2-20.48c10.506-4.198 15.605-16.118 11.407-26.624z"
          fill="" data-original="#000000"></path>
      </g>
      <!-- <path *ngIf="place.wheelchair_accessible_entrance===false" [attr.fill]="getFill('wheelchair_accessible_entrance')"
        [attr.stroke]="getFill('wheelchair_accessible_entrance')" fill="none" stroke-width="30"
        d="m85.587 85.587 340.826 340.826M290.815 "></path> -->
    </svg>
    <div *ngIf="showText" class="text-center">
      <div class="mt-2">Wheelchair</div>
      <div *ngIf="place.wheelchair_accessible_entrance" class="text-green-500 font-semibold">YES</div>
      <div *ngIf="!place.wheelchair_accessible_entrance" class="text-red-500 font-semibold">NO</div>
    </div>
  </div>

</div>